import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { Text, Button, tokens } from '@hotjar/hotsauce';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';
import { useHotjarTips } from '@hotjar/webapp/domains/activation/start-page';
import { DismissableArticle } from './DismissableArticle';
import { HOTJAR_TIPS } from './data';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${tokens.spacer.x1pt5};
`;

const TipsWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 0;
  list-style: none;
`;

export const HotjarTipsSection = (): JSX.Element => {
  const { click: trackClick } = useTrack();
  const { t } = useTranslation();
  const { data: allTipsIds } = useHotjarTips() || [];
  const topTipsIds = allTipsIds?.slice(0, 2);

  const handleViewAllClick = () => {
    trackClick(`view all`, 'for you - hotjar tips section', {});
  };

  const handlePostClick = (postId: string) => {
    trackClick(`tip click - ${postId}`, 'for you - hotjar tips section', {});
  };

  return (
    <Wrapper>
      <Header>
        <Text as="h2" textType="header5">
          {t('activation:space-overview.for-you.hotjar-tips.title')}
        </Text>
        <Button
          as="a"
          isExternal
          icon="open_new_window"
          href="https://learning.hotjar.com/"
          onClick={handleViewAllClick}
          kind="ghost"
        >
          {t('activation:space-overview.for-you.hotjar-tips.view-all')}
        </Button>
      </Header>
      <TipsWrapper data-testid="hotjar-tips-list">
        {topTipsIds?.map((tipId, tipIndex) => {
          return (
            <DismissableArticle
              key={tipId}
              id={tipId}
              article={HOTJAR_TIPS[tipId]}
              tipIndex={tipIndex}
              onClick={handlePostClick}
            />
          );
        })}
      </TipsWrapper>
    </Wrapper>
  );
};
